import React from "react";
import { CheckCircle } from "lucide-react";
import SectionHeading from "../ui/SectionHeading";
import CTAButton from "../ui/CTAButton";

const features = [
  "Experienced team of tax, VAT, RJSC, BIDA and finance professionals",
  "Comprehensive business consultancy services",
  "Personalized solutions for unique business needs",
  "Up-to-date with latest regulatory changes",
  "Strategic planning for long-term financial success",
  "Dedication to client satisfaction and results",
];

const AboutPreview = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative z-10 rounded-lg overflow-hidden shadow-lg">
              <img
                src="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                alt="Professional Service Associates team"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute top-10 -left-10 w-full h-full rounded-lg bg-psa-gold-100 -z-10"></div>
          </div>

          <div>
            <SectionHeading
              title="About Professional Service Associates"
              subtitle="We are a dedicated team of tax, VAT, RJSC, BIDA and business consultants committed to helping businesses & individuals navigate complex financial landscapes."
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle
                    size={20}
                    className="text-psa-green-600 mr-3 mt-1 flex-shrink-0"
                  />
                  <p className="text-gray-700">{feature}</p>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <CTAButton to="/about">Learn More About Us</CTAButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
